(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lk-pack-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lk-pack-details')) customElements.define('lk-pack-details', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    const card = this.closest('.product-item');
    const scope = card || this.closest('.productView');
    const quantityInputs = () => scope ? Array.from(scope.querySelectorAll('input[name="quantity"]')) : [];
    const gcd = (a, b) => b ? gcd(b, a % b) : a;
    const limit = value => value === '' || value === undefined || value === null ? Infinity : Number(value);
    const packRules = (panel, kind) => {
      const box = Number(panel.dataset.box) || 1;
      const ruleStep = Number(panel.dataset.increment) || 1;
      const baseStep = box * ruleStep / gcd(box, ruleStep);
      const carton = Number(panel.dataset.carton) || 0;
      const size = kind === 'carton' ? carton : box;
      const step = kind === 'carton' ? carton : baseStep;
      const validPack = size > 0 && (kind !== 'carton' || carton % baseStep === 0);
      const minimum = validPack ? Math.ceil(Math.max(Number(panel.dataset.min) || 1, size) / step) * step : Infinity;
      const maximum = limit(panel.dataset.max);
      return { size, step, minimum, maximum, validPack: validPack && minimum <= maximum };
    };
    const validQuantity = (panel, quantity, kind = this.dataset.packKind || 'box') => {
      const rule = packRules(panel, kind);
      return rule.validPack && Number.isInteger(quantity) && quantity >= rule.minimum && quantity <= rule.maximum && quantity % rule.step === 0;
    };
    const normalizeQuantity = (panel, quantity) => {
      const rule = packRules(panel, this.dataset.packKind || 'box');
      if (!rule.validPack) return 0;
      return Math.min(Math.floor(rule.maximum / rule.step) * rule.step, Math.max(rule.minimum, Math.ceil((Number(quantity) || rule.minimum) / rule.step) * rule.step));
    };
    const syncPackInputs = (panel, quantity) => {
      const kind = this.dataset.packKind || 'box';
      const rule = packRules(panel, kind);
      quantityInputs().forEach(input => {
        input.min = rule.minimum;
        input.step = rule.step || 1;
        if (Number.isFinite(rule.maximum)) input.max = rule.maximum;
        else input.removeAttribute('max');
        if (quantity) input.value = quantity;
        input.setCustomValidity?.(quantity ? '' : this.dataset.packUnavailableLabel);
      });
      if (!card && scope) scope.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
        let property = form.querySelector('input[name="properties[_lk_pack_kind]"]');
        if (!property) {
          property = document.createElement('input');
          property.type = 'hidden';
          property.name = 'properties[_lk_pack_kind]';
          form.append(property);
        }
        property.value = kind;
      });
    };
    const currency = this.dataset.currency || 'USD';
    const locale = this.dataset.locale || 'en';
    const formatter = new Intl.NumberFormat(locale, { style: 'currency', currency });
    const money = cents => formatter.format(cents / 100);
    const parts = new Intl.NumberFormat(locale).formatToParts(12345.6);
    const group = parts.find(part => part.type === 'group')?.value || ',';
    const decimal = parts.find(part => part.type === 'decimal')?.value || '.';
    const readAccountPrice = panel => {
      const source = panel.querySelector('[data-account-unit]');
      if (!source || !source.classList.contains('pre-money')) return null;
      const copy = source.cloneNode(true);
      copy.querySelectorAll('del, s, .bold-pre-compare-price').forEach(node => node.remove());
      const text = copy.textContent.trim();
      if (!text || !/\d/.test(text)) return null;
      const amount = Number(text.split(group).join('').replace(decimal, '.').replace(/[^0-9.-]/g, ''));
      return Number.isFinite(amount) && amount >= 0 ? Math.round(amount * 100) : null;
    };
    const setPriceText = (node, text) => { if (node.textContent !== text) node.textContent = text; };
    const updatePriceMath = (panel, quantity) => {
      const block = panel.querySelector('[data-price-explainer]');
      if (!block) return;
      const regular = Number(panel.dataset.regularCents);
      const account = block.hasAttribute('data-account-pricing');
      const unit = account ? readAccountPrice(panel) : null;
      const ready = quantity > 0 && Number.isFinite(regular) && (!account || (unit !== null && unit <= regular));
      block.querySelector('[data-price-math]').hidden = !ready;
      const loading = block.querySelector('[data-price-loading]');
      if (loading) loading.hidden = unit !== null;
      const subtotal = count => account ? unit * count : regular * count - Math.round(regular * count * 35 / 100);
      panel.querySelectorAll('[data-pack-total]').forEach(node => {
        node.hidden = !ready;
        if (ready) setPriceText(node, node.dataset.label.replace('__total__', money(subtotal(Number(node.dataset.quantity)))));
      });
      if (!ready) return;
      const total = subtotal(quantity);
      const saving = Math.max(0, regular * quantity - total);
      const rate = account ? (regular > 0 ? Math.max(0, (regular - unit) * 100 / regular) : 0) : 35;
      const percent = new Intl.NumberFormat(locale, { maximumFractionDigits: 1 }).format(rate);
      const label = block.querySelector('[data-regular-label]');
      setPriceText(label, label.dataset.label.replace('__quantity__', String(quantity)).replace('__price__', money(regular)));
      const savingsLabel = block.querySelector('[data-saving-label]');
      setPriceText(savingsLabel, savingsLabel.dataset.label.replace('__percent__', percent));
      setPriceText(block.querySelector('[data-regular-total]'), money(regular * quantity));
      setPriceText(block.querySelector('[data-saving-total]'), '−' + money(saving));
      setPriceText(block.querySelector('[data-discounted-total]'), money(total));
      const itemLabel = block.querySelector('[data-item-discount]');
      if (itemLabel) {
        itemLabel.hidden = false;
        setPriceText(itemLabel, itemLabel.dataset.label.replace('__percent__', percent));
      }
    };
    const markQuantity = (panel, quantity) => {
      panel.dataset.chosenQuantity = String(quantity);
      updatePriceMath(panel, quantity);
      panel.querySelectorAll('[data-pack-quantity]').forEach(button => {
        const kind = button.dataset.packKind;
        button.disabled = !packRules(panel, kind).validPack;
        button.setAttribute('aria-pressed', String(!button.disabled && kind === (this.dataset.packKind || 'box')));
      });
      const status = panel.querySelector('[data-pack-status]');
      if (status) {
        status.hidden = !quantity;
        const kind = this.dataset.packKind || 'box';
        const size = packRules(panel, kind).size;
        const label = kind === 'carton' ? this.dataset.cartonQuantityLabel : this.dataset.boxQuantityLabel;
        setPriceText(status, quantity ? label.replace('__packs__', String(quantity / size)).replace('__size__', String(size)).replace('__quantity__', String(quantity)) : '');
      }
    };
    const setQuantity = (panel, quantity, notify = false) => {
      const normalized = normalizeQuantity(panel, quantity);
      syncPackInputs(panel, normalized);
      markQuantity(panel, normalized);
      if (notify) quantityInputs().forEach(input => {
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    };
    this.addEventListener('click', event => {
      const button = event.target.closest('[data-pack-quantity]');
      if (!button || button.disabled || !this.contains(button)) return;
      const panel = button.closest('[data-pack-variant]');
      if (panel.hidden) return;
      this.dataset.packKind = button.dataset.packKind;
      setQuantity(panel, packRules(panel, this.dataset.packKind).minimum, true);
    });
    const currentPanel = () => this.querySelector('[data-pack-variant]:not([hidden])');
    if (!card && scope) {
      scope.addEventListener('click', event => {
        const button = event.target.closest('quantity-input button[name="plus"], quantity-input button[name="minus"]');
        if (!button || !button.closest('quantity-input')?.querySelector('input[name="quantity"]')) return;
        const panel = currentPanel();
        if (!panel) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const current = Number(quantityInputs()[0]?.value) || Number(panel.dataset.chosenQuantity);
        const step = packRules(panel, this.dataset.packKind || 'box').step;
        setQuantity(panel, current + (button.name === 'plus' ? step : -step), true);
      }, true);
      scope.addEventListener('change', event => {
        if (!quantityInputs().includes(event.target)) return;
        const panel = currentPanel();
        if (panel) setQuantity(panel, event.target.value);
      }, true);
      scope.addEventListener('submit', event => {
        if (!event.target.matches('form[action*="/cart/add"]')) return;
        const panel = currentPanel();
        if (!panel) return;
        setQuantity(panel, quantityInputs()[0]?.value || panel.dataset.chosenQuantity);
        if (!validQuantity(panel, Number(panel.dataset.chosenQuantity))) {
          event.preventDefault();
          event.stopImmediatePropagation();
          quantityInputs()[0]?.reportValidity();
        }
      }, true);
    }
    const show = id => {
      const panels = Array.from(this.querySelectorAll('[data-pack-variant]'));
      const panel = panels.find(p => p.dataset.packVariant === String(id));
      if (!panel) return;
      const changedVariant = this.dataset.activeVariant !== String(id);
      this.dataset.activeVariant = String(id);
      panels.forEach(p => p.hidden = p !== panel);
      if (!packRules(panel, this.dataset.packKind || 'box').validPack) this.dataset.packKind = 'box';
      const quantity = changedVariant ? packRules(panel, this.dataset.packKind || 'box').minimum : Number(quantityInputs()[0]?.value) || Number(panel.dataset.chosenQuantity) || Number(panel.dataset.min);
      setQuantity(panel, quantity);
    };
    if (card) {
      card.addEventListener('click', e => {
        const swatch = e.target.closest('[data-variant-id]');
        if (swatch) show(swatch.dataset.variantId);
      });
      card.addEventListener('change', e => {if(e.target.matches('[data-lk-variant]')) show(e.target.value);});
    } else {
      document.addEventListener('change', () => setTimeout(() => show(new URL(location.href).searchParams.get('variant') || this.dataset.selected),100));
    }
    this.querySelectorAll('[data-account-unit]').forEach(source => {
      const panel = source.closest('[data-pack-variant]');
      const observer = new MutationObserver(() => updatePriceMath(panel, Number(panel.dataset.chosenQuantity) || Number(panel.dataset.min)));
      observer.observe(source, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    });
    show(this.dataset.selected);
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lk-search-order"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lk-search-order')) {
  customElements.define('lk-search-order', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const card = this.closest('.product-item');
      const select = this.querySelector('[data-lk-variant]');
      const sku = this.querySelector('[data-lk-sku]');
      const sync = () => {
        const option = select.selectedOptions[0];
        if (!option) return;
        sku.textContent = option.dataset.sku || '—';
        this.querySelector('button[type="submit"]').disabled = option.disabled;
        const quantity = this.querySelector('[name="quantity"]');
        quantity.min = option.dataset.min || '1';
        quantity.step = option.dataset.step || '1';
        if (option.dataset.max) quantity.max = option.dataset.max;
        else quantity.removeAttribute('max');
        const pack = card?.querySelector('[data-pack-variant="' + option.value + '"]');
        const box = Number(pack?.dataset.box) || 0;
        if (box > 0) {
          const step = Number(quantity.step) || 1;
          const gcd = (a,b) => b ? gcd(b,a%b) : a;
          quantity.step = box * step / gcd(box,step);
          quantity.min = Math.ceil(Math.max(Number(quantity.min), Number(pack.dataset.min)) / Number(quantity.step)) * Number(quantity.step);
        } else {
          this.querySelector('button[type="submit"]').disabled = true;
        }
        quantity.value = quantity.min;
      };
      if (select) { select.addEventListener('change', sync); sync(); }
      if (card) card.addEventListener('click', event => {
        const swatch = event.target.closest('.swatch-label[data-variant-id]');
        if (!swatch) return;
        const data = JSON.parse(card.dataset.jsonProduct || '{}');
        const variant = (data.variants || []).find(v => String(v.id) === swatch.dataset.variantId);
        if (!variant) return;
        sku.textContent = variant.sku || '—';
        if (select) { select.value = String(variant.id); sync(); }
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
